import C5UsuarioCadastroModel from "./C5UsuarioCadastroModel";

class UsuarioCadastroModel {
  usuarioId?: string = "";
  nome: string = "";
  email: string = "";
  senha: string = "";
  facebookId: string = "";
  googleId: string = "";
  telefone: string = "";
  documento: string = "";
  nascimento: string = "";
  sexo: string = "";

  public static toModel(obj: UsuarioCadastroModel): C5UsuarioCadastroModel {
    return {
      Name: obj.nome,
      BirthDate: obj.nascimento,
      DocumentNumber: obj.documento,
      Email: obj.email,
      FacebookID: obj.facebookId,
      Gender: obj.sexo,
      GoogleID: obj.googleId,
      Password: obj.senha,
      PhoneNumber: +obj.telefone,
    };
  }
  public static toModelAtualizar(
    obj: UsuarioCadastroModel
  ): C5UsuarioCadastroModel {
    return {
      ClientID: obj.usuarioId ? +obj.usuarioId : -1,
      Name: obj.nome,
      BirthDate: obj.nascimento,
      DocumentNumber: obj.documento,
      FacebookID: obj.facebookId,
      Gender: obj.sexo,
      GoogleID: obj.googleId,
      PhoneNumber: +obj.telefone,
    };
  }

  public static toModelAtualizarComSenha(
    obj: UsuarioCadastroModel
  ): C5UsuarioCadastroModel {
    return {
      ClientID: obj.usuarioId ? +obj.usuarioId : -1,
      Name: obj.nome,
      BirthDate: obj.nascimento,
      DocumentNumber: obj.documento,
      FacebookID: obj.facebookId,
      Gender: obj.sexo,
      GoogleID: obj.googleId,
      PhoneNumber: +obj.telefone,
      Password: obj.senha,
    };
  }

  public static toRecuperarSenha(obj: UsuarioCadastroModel): any {
    return {
      FirstName: obj.nome,
      Password: obj.senha,
      Email: obj.email,
      Id: obj.usuarioId,
    };
  }
}

export default UsuarioCadastroModel;
